import { render, staticRenderFns } from "./contingencyInfo.vue?vue&type=template&id=0f2f153f&scoped=true&"
import script from "./contingencyInfo.vue?vue&type=script&lang=js&"
export * from "./contingencyInfo.vue?vue&type=script&lang=js&"
import style0 from "./contingencyInfo.vue?vue&type=style&index=0&id=0f2f153f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2f153f",
  null
  
)

export default component.exports